import React from "react";
import { Quote } from "lucide-react";

export default function Testimonial() {
  return (
    <section className="section-dark">
      <div className="max-w-5xl mx-auto px-6 md:px-10 py-20 md:py-28 text-center">
        <p className="eyebrow eyebrow-line" style={{ color: "#a9b891" }}>From a Client</p>
        <Quote className="w-10 h-10 mx-auto mt-8 text-[#8a9a6b]" strokeWidth={1} />
        <blockquote className="font-serif-display mt-8 text-[1.9rem] md:text-[2.6rem] leading-[1.25] text-[#dde3d0] italic">
          “They are the one seat at our property table with nothing to sell us. On its own, that clarity has already paid for the fee.”
        </blockquote>
        <p className="mt-10 text-sm tracking-widest uppercase text-[#8ea27a]">
          — Family Office Principal · Singapore
        </p>
      </div>
    </section>
  );
}
